import { render } from "./PPAPApplicabilityEvaluationList.vue?vue&type=template&id=701c8865&scoped=true"
import script from "./PPAPApplicabilityEvaluationList.vue?vue&type=script&lang=js"
export * from "./PPAPApplicabilityEvaluationList.vue?vue&type=script&lang=js"

import "./PPAPApplicabilityEvaluationList.vue?vue&type=style&index=0&id=701c8865&lang=scss"
import "./PPAPApplicabilityEvaluationList.vue?vue&type=style&index=1&id=701c8865&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-701c8865"]])

export default __exports__